import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  ConfirmationWithCommentDialogContext,
  ConfirmationWithCommentDialogInitialState,
} from "./";

export const ConfirmationWithCommentDialogStateProvider = ({
  children,
}: any) => {
  const [pageState, setPageState] = useState(
    ConfirmationWithCommentDialogInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <ConfirmationWithCommentDialogContext.Provider value={context}>
      {children}
    </ConfirmationWithCommentDialogContext.Provider>
  );
};
